const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Eftpos24 = function Eftpos24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M6.938 4.998a8.978 8.978 0 0 0 5.62 15.98c3.355 0 6.346-1.875 7.815-4.57.047-.086.072-.179.011-.256-.105-.134-.266-.07-.41.017-1.345.809-2.495 1.187-4.132 1.187-3.566 0-6.456-2.544-6.456-5.682 0-2.487 1.675-4.653 4.152-5.784-.665-1.27-2.139-1.786-3.584-1.786-1.173 0-2.327.34-3.016.894Z",
      fill: "url(#paint0_linear_101_2)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M20.27 9.367c0 2.982-2.849 5.4-6.362 5.4-.512 0-1.896-.07-2.886-.532-.282-.131-.253-.296-.06-.376.45-.186 3.981-.863 3.981-4.492 0-3.63-3.746-6.282-8.005-4.37a8.94 8.94 0 0 1 5.62-1.975c4.17 0 7.711 2.84 7.711 6.345Z",
      fill: "#E50056",
    }),
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "linearGradient",
        {
          id: "paint0_linear_101_2",
          x1: "12.078",
          y1: "14.959",
          x2: "8.643",
          y2: "-2.716",
          gradientUnits: "userSpaceOnUse",
        },
        /*#__PURE__*/ React.createElement("stop", {
          stopColor: "#E50056",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: ".141",
          stopColor: "#E50056",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: ".75",
          stopColor: "#1F0038",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "1",
          stopColor: "#1F0038",
        })
      )
    )
  );
};
Eftpos24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Eftpos32 = function Eftpos32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: "0.5",
      y: "0.5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "white",
      stroke: "#CCCCCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M11.4926 5.76061C9.66791 7.22686 8.5 9.47702 8.5 12C8.5 16.4183 12.0817 20 16.5 20C19.4901 20 22.1548 18.3297 23.4643 15.9272C23.5055 15.8513 23.5282 15.7685 23.4742 15.7002C23.3798 15.5808 23.2366 15.6382 23.1091 15.7145C21.9102 16.4357 20.8848 16.7726 19.4266 16.7726C16.2494 16.7726 13.6738 14.5058 13.6738 11.7094C13.6738 9.49373 15.1665 7.56345 17.3735 6.55561C16.7804 5.42454 15.4675 4.96434 14.1795 4.96434C13.1348 4.9644 12.1065 5.26726 11.4926 5.76061Z",
      fill: "url(#paint0_linear_21980_148)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M23.3717 9.65355C23.3717 12.3109 20.8338 14.4651 17.703 14.4651C17.2474 14.4651 16.014 14.4024 15.1313 13.9916C14.8802 13.8748 14.906 13.7277 15.0785 13.6565C15.4797 13.491 18.6259 12.8873 18.6259 9.65355C18.6259 6.41988 15.2871 4.05552 11.4927 5.76051C12.8634 4.65902 14.6048 3.99992 16.5001 3.99992C20.2154 3.99992 23.3717 6.53113 23.3717 9.65355Z",
      fill: "#E50056",
    }),
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "linearGradient",
        {
          id: "paint0_linear_21980_148",
          x1: "16.0728",
          y1: "14.6368",
          x2: "13.0114",
          y2: "-1.11275",
          gradientUnits: "userSpaceOnUse",
        },
        /*#__PURE__*/ React.createElement("stop", {
          stopColor: "#E50056",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.141092",
          stopColor: "#E50056",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.75",
          stopColor: "#1F0038",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "1",
          stopColor: "#1F0038",
        })
      )
    )
  );
};
Eftpos32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Eftpos24,
  32: Eftpos32,
};
export function Eftpos(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Eftpos' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
